
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, Validators, ValidationErrors, UntypedFormControl } from '@angular/forms';
import { AssessmentTypeEdit } from '../../model/assessment-type.edit';
import { Observable } from 'rxjs';
import { merge } from 'lodash';
import { AssessmentValidators } from 'src/app/core/validators/assessment.validators';

@Component({
  selector: 'app-assessment-type-edit',
  templateUrl: './assessment-type-edit.component.html',
  styleUrls: ['./assessment-type-edit.component.scss']
})
export class AssessmentTypeEditComponent
{
  @Input() public isNew = false;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<AssessmentTypeEdit> = new EventEmitter();

  public editForm: any;
  public editFormActive = false;

  private assessmentTypeEdit: AssessmentTypeEdit;

  constructor(
    private fb: UntypedFormBuilder,
    private assessmentValidators: AssessmentValidators)
  { }

  public get name(): UntypedFormControl
  {
    return this.editForm.get('name');
  }

  public get consentType(): UntypedFormControl
  {
    return this.editForm.get('consentType');
  }

  @Input() public set model(assessmentType: AssessmentTypeEdit)
  {
    this.initModel(assessmentType);
  }

  public onSave(e: Event): void
  {
    e.preventDefault();
    const objectToPersist = merge(this.assessmentTypeEdit, this.editForm.value);

    this.save.emit(objectToPersist);
    this.editFormActive = false;
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeEditForm();
  }

  private closeEditForm(): void
  {
    this.editFormActive = false;
    this.cancelling.emit();
  }

  private initModel(assessmentType: AssessmentTypeEdit)
  {
    if (assessmentType === undefined)
    {
      return;
    }
    // Set the current category id used for name async validators
    const previousAssessmentTypeName = this.isNew ? '' : assessmentType.name;

    // Set form
    this.editForm = this.fb.group({
      id: [null],
      name: [
        { value: '', disabled: false },
        {
          validators: [Validators.required],
          asyncValidators: (): Observable<ValidationErrors | null> =>
            this.assessmentValidators.validateAssessmentTypeNameUnique(this.editForm.get('name'), previousAssessmentTypeName)
        }
      ],
      consentType: { value: false, disabled: !this.isNew },
      active: { value: true, disabled: false }
    });

    this.editForm.reset(assessmentType);
    this.assessmentTypeEdit = assessmentType;
    this.editFormActive = true;
  }

}
